import moment, { Moment } from "moment-timezone"
import { withContext as withContext_ } from "react-context-consumer-hoc"
import { Maybe, MerchantInfoQueryMibLocations } from "../../graphql/generated-types"
import { CartProduct } from "./types"

export const withContext = withContext_

export const getHotjarUserId = () => {
    return null
}

export const getPersistedOrderScheduledDate = (
    persistedOrderScheduledDate: Maybe<string>,
    locationInfo: MerchantInfoQueryMibLocations
): Maybe<Moment> => {
    if (persistedOrderScheduledDate) {
        const locationSettings = locationInfo.settings
        if (!locationSettings.acceptFutureOrdersForDelivery && !locationSettings.acceptFutureOrdersForPickUp) {
            return null
        }
        const orderScheduledDate = moment.tz(persistedOrderScheduledDate, locationInfo.timezone)
        if (orderScheduledDate.isBefore(moment.tz(locationInfo.timezone))) {
            return null
        }

        // Check whether delivery/pickup is disabled until some time - reset schedule date if is within disabled time
        const disabledUntil =
            locationInfo.settings.isDisabledConfig &&
            locationInfo.settings.isDisabledConfig.until &&
            (locationInfo.settings.isDisabledConfig.forPickup || locationInfo.settings.isDisabledConfig.forDelivery)

        if (disabledUntil) {
            const disabledUntilMoment = moment.tz(disabledUntil, locationInfo.timezone)
            if (orderScheduledDate.isBefore(disabledUntilMoment)) {
                return null
            }
        }

        return orderScheduledDate
    }
    return null
}

export const shouldRemoveCartItems = (itemsAddedToCartDate: Maybe<string>, products: CartProduct[]) =>
    (itemsAddedToCartDate && moment.duration(moment().diff(moment(itemsAddedToCartDate))).asHours() > 48) ||
    (products.length > 0 && !itemsAddedToCartDate)

export const shouldExtendItemsAddedDate = (itemsAddedToCartDate: Maybe<string>, products: CartProduct[]) =>
    products.length > 0 &&
    (!itemsAddedToCartDate ||
        (itemsAddedToCartDate && moment.duration(moment().diff(moment(itemsAddedToCartDate))).asHours() <= 48))
